/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q3Inputs */

const en_pc_faq_q3 = /** @type {(inputs: Pc_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PDFCraftTool.org the official PdfCraft site?`)
};

const zh_pc_faq_q3 = /** @type {(inputs: Pc_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFCraftTool.org 是 PdfCraft 官网吗？`)
};

/**
* | output |
* | --- |
* | "Is PDFCraftTool.org the official PdfCraft site?" |
*
* @param {Pc_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q3 = /** @type {((inputs?: Pc_Faq_Q3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q3(inputs)
	return zh_pc_faq_q3(inputs)
});
export { pc_faq_q3 as "pc.faq.q3" }